import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
const items = ['Esplorare i 6 volumi', 'Consultare i protocolli', 'Utilizzare le checklist', 'Studiare i framework visivi'];
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-184" data-mp="29dwxzxmb5dwy">
      <div className="mx-auto max-w-2xl" data-id="element-185" data-mp="29f81dwbucjnj">
        <div className="rounded-3xl border-2 border-brand/30 bg-white p-6 text-center sm:p-8" data-id="element-186" data-mp="2edjag4ubaq4p">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-light" data-id="element-187" data-mp="2jbun0nbzreqm">
            <ShieldCheckIcon className="h-7 w-7 text-brand-dark" aria-hidden="true" data-id="element-188" data-mp="2oanvu2gc2hkg" />
          </span>
          <h2 className="mt-4 font-display text-[24px] font-bold leading-tight text-navy sm:text-3xl" data-id="element-189" data-mp="2sd2i6wj7nzgh">
            La tua garanzia di 7 giorni
          </h2>
          <p className="mt-2 text-[15px] font-semibold text-brand-dark" data-id="element-190" data-mp="tzizlj7kt7f5">Prova il Sistema completamente senza rischi</p>
          <p className="mt-4 text-[14.5px] leading-relaxed text-navy/70" data-id="element-191" data-mp="3sl6i9oxqqxr4">
            Vogliamo che tu ti senta sicuro della tua decisione. Per questo hai 7 giorni completi per esplorare Il
            Sistema Maestro di Pianificazione con Allineatori™.
          </p>

          <ul className="mx-auto mt-5 grid max-w-sm gap-2 text-left sm:grid-cols-2" data-id="element-192" data-mp="3ivwtoj23vx7r">
            {items.map(item => <li key={item} className="flex items-start gap-2 rounded-xl bg-cream px-3 py-2.5 text-[13px] font-semibold leading-snug text-navy" data-id="element-193" data-mp="fewn5mnurum4">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-194" data-mp="adz4l8yxkyk3" />
                {item}
              </li>)}
          </ul>

          <p className="mt-5 text-[14px] leading-relaxed text-navy/70" data-id="element-195" data-mp="h4dhb4zm0fu">
            Se non ritieni che il Sistema ti fornisca risorse utili per la pianificazione clinica, contattaci entro 7
            giorni e richiedi il rimborso. Nessun processo complicato. Nessuna domanda inutile.
          </p>

          <CtaBlock className="mt-7" label="Provalo senza rischi per 7 giorni" data-id="element-196" data-mp="1d97eou9x0u8l" />
        </div>
      </div>
    </section>;
}